module.exports = __webpack_public_path__ + "static/media/YM80_2.39d36128.jpg";